module.exports = __webpack_public_path__ + "static/media/discoverModel.47921218.svg";